module.exports = "https://cdn.dove.it/_next/static/public/assets/services/consulenti_340x200.fe2351fe864ce29fff09a34dc39e968f.jpg";